import { render, staticRenderFns } from "./ExamNotes.vue?vue&type=template&id=e65a9642"
import script from "./ExamNotes.vue?vue&type=script&lang=js"
export * from "./ExamNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports